export function toBIPrice(value) {
  return _.round(value * 10000);
}



// WEBPACK FOOTER //
// ./src/shared/utils/bi/price.js